module.exports = __webpack_public_path__ + "media/images/country_flags/cu-fdcc2075dc01347a49d46a26463b0cf7.png";